/**
 * Timely Widget Loader
 * Optimized async loading for booking widget
 * Load with: <script src="timely-widget.js" async defer></script>
 */

(function () {
  "use strict";

  // Early exit if already loaded
  if (window.timelyWidgetLoaded) return;
  window.timelyWidgetLoaded = true;

  /**
   * Load Timely booking widget asynchronously
   */
  function loadTimelyWidget() {
    try {
      var script = document.createElement("script");
      script.id = "timelyScript";
      script.src = "//book.gettimely.com/widget/book-button-v1.5.js";
      script.async = true;
      script.onload = function () {
        console.log("✅ Timely widget loaded successfully");
      };
      script.onerror = function () {
        console.warn("⚠️ Timely widget failed to load");
      };
      document.head.appendChild(script);
    } catch (error) {
      console.warn("Timely widget initialization failed:", error);
    }
  }

  // Load immediately since this script is already deferred
  loadTimelyWidget();
})();
